"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkupManagerProxy = void 0;
const multimap_1 = require("../../../util/multimap");
const LinkupAddress_1 = require("../LinkupAddress");
class LinkupManagerProxy {
    constructor(commandForwardingFn) {
        this.commandForwardingFn = commandForwardingFn;
        this.messagesNewCallCallbacks = new multimap_1.MultiMap();
        this.messagesOnCallCallbacks = new multimap_1.MultiMap();
        this.rawMessageCallbacks = new multimap_1.MultiMap();
        this.queryResponseCallbacks = new multimap_1.MultiMap();
        this.linkupManagerEventIngestFn = (ev) => {
            if (ev.type === 'new-call-message') {
                const newCall = ev;
                for (const cb of this.messagesNewCallCallbacks.get(newCall.recipient)) {
                    const sender = LinkupAddress_1.LinkupAddress.fromURL(newCall.sender);
                    const recipient = LinkupAddress_1.LinkupAddress.fromURL(newCall.recipient);
                    try {
                        cb(sender, recipient, newCall.callId, newCall.message);
                    }
                    catch (e) {
                        console.log('Error in callback invocation within LinkupManagerProxy: ', e);
                    }
                }
            }
            else if (ev.type === 'raw-message-event') {
                const raw = ev;
                for (const cb of this.rawMessageCallbacks.get(raw.recipient)) {
                    const sender = LinkupAddress_1.LinkupAddress.fromURL(raw.sender);
                    const recipient = LinkupAddress_1.LinkupAddress.fromURL(raw.recipient);
                    try {
                        cb(sender, recipient, raw.message);
                    }
                    catch (e) {
                        console.log('Error in callback invocation within LinkupManagerProxy: ', e);
                    }
                }
            }
            else if (ev.type === 'listening-addresses-query-response') {
                const response = ev;
                for (const cb of this.queryResponseCallbacks.get(response.queryId)) {
                    const listening = response.matches.map((ep) => LinkupAddress_1.LinkupAddress.fromURL(ep));
                    try {
                        cb(response.queryId, listening);
                    }
                    catch (e) {
                        console.log('Error in callback invocation within LinkupManagerProxy: ', e);
                    }
                }
            }
            else if (ev.type === 'message-on-call') {
                const msg = ev;
                for (const cb of this.messagesOnCallCallbacks.get(msg.recipient + '/' + msg.callId)) {
                    try {
                        cb(msg.message);
                    }
                    catch (e) {
                        console.log('Error in callback invocation within LinkupManagerProxy: ', e);
                    }
                }
            }
        };
    }
    listenForMessagesNewCall(recipient, callback) {
        const cmd = {
            type: 'listen-for-messages-new-call',
            recipient: recipient.url()
        };
        this.messagesNewCallCallbacks.add(cmd.recipient, callback);
        this.commandForwardingFn(cmd);
    }
    listenForMessagesOnCall(recipient, callId, callback) {
        const cmd = {
            type: 'listen-for-messages-on-call',
            recipient: recipient.url(),
            callId: callId
        };
        this.messagesOnCallCallbacks.add(cmd.recipient + '/' + callId, callback);
        this.commandForwardingFn(cmd);
    }
    listenForRawMessages(recipient, callback) {
        const cmd = {
            type: 'listen-for-raw-messages',
            recipient: recipient.url()
        };
        this.rawMessageCallbacks.add(cmd.recipient, callback);
        this.commandForwardingFn(cmd);
    }
    sendMessageOnCall(sender, recipient, callId, data) {
        const cmd = {
            type: 'send-message-on-call',
            sender: sender.url(),
            recipient: recipient.url(),
            callId: callId,
            data: JSON.parse(JSON.stringify(data))
        };
        this.commandForwardingFn(cmd);
    }
    sendRawMessage(sender, recipient, data, sendLimit) {
        const cmd = {
            type: 'send-raw-message',
            sender: sender.url(),
            recipient: recipient.url(),
            data: data,
            sendLimit: sendLimit
        };
        this.commandForwardingFn(cmd);
    }
    listenForQueryResponses(queryId, callback) {
        const cmd = {
            type: 'listen-for-query-responses',
            queryId: queryId
        };
        this.queryResponseCallbacks.add(queryId, callback);
        this.commandForwardingFn(cmd);
    }
    queryForListeningAddresses(queryId, addresses) {
        const cmd = {
            type: 'query-for-listening-addresses',
            queryId: queryId,
            addresses: addresses.map((addr) => addr.url())
        };
        this.commandForwardingFn(cmd);
    }
}
exports.LinkupManagerProxy = LinkupManagerProxy;
//# sourceMappingURL=LinkupManagerProxy.js.map